export const enClientPortalValuationIncomePage = {
    formulas: {
        grossInitialYield: '\\frac{\\text{Contract rent} \\times 100}{\\text{Market value}}',
        grossYield: '\\frac{\\text{Market rent} \\times 100}{\\text{Market value}}',
        grossYieldMultiplier: '\\frac{\\text{Market value}}{\\text{Gross rental income}}',
        netYieldMultiplier: '\\frac{\\text{Market value}}{\\text{Net rental income}}',
    },
    sensitivityMatrix: {
        infoTitle: 'Rounding',
        infoText: 'The sensitivity matrix results are shown unrounded to avoid distortion.',
        legendLabel: 'Legend',
        deltaToMarketValue: 'Delta to market value',
        capitalValue: 'Capital value',
        actualMultiplier: 'Actual multiplier',
        actualGrossInitialYield: 'Actual gross initial yield',
    },
}
